/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @format
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import { toast } from 'react-toastify';
import Header from './Header';
import Footer from './Footer';
import ToolsWrapper from './ToolsWrapper';
import { TmsComponents } from '../../../../enums';
import FireboardUtils from '../../../../util/fireboard-util';

const defaultState = {
  isComponentAdding: false,
  toolType: null,
  subTools: [],
  selectedSubTool: undefined,
  tables: [],
  selectedTable: undefined,
  selectedTableShape: undefined,
};

const LeftSection = ({
  onSave,
  initShape,
  closeLayoutEditor,
  onDeleteShape,
  onDeleteLayout,
  storeLayoutBySensorGroup,
  selectedSensorGrpId,
  onChangeSensorGroup,
  getAssignedAndUnAssignedTables,
  getAllTablesInfo,
  selectedShape,
  onChangeShape,
  onSelectStation,
  selectShape
}) => {
  const [state, setState] = React.useState(defaultState);
  const { labelsData } = useSelector(state => state);
  const labels = labelsData?.labels;

  const onStart = () => {
    selectShape && selectShape(null); //remove shape selection if any
    setState(prevState => ({
      ...prevState,
      isComponentAdding: true,
    }));
  };

  const onClickTool = (tool) => {
    setState(prevState => ({
      ...prevState,
      toolType: tool.type,
      subTools: tool.toolsArray,
      selectedSubTool: undefined,
    }));
  };

  const onClickSubTool = (subTool) => {
    let tables = [];
    if (state.toolType === TmsComponents.table) {
      if (subTool?.type !== TmsComponents.tableAll) {
        const { unAssignedTables } = getAssignedAndUnAssignedTables(subTool?.seatCapacity);
        tables = unAssignedTables;
      }
    }

    setState(prevState => ({
      ...prevState,
      selectedSubTool: subTool,
      tables,
      selectedTable: undefined,
      selectedTableShape: undefined,
    }));
  };

  const onChooseOrientation = tableShape => {
    setState(prevState => ({
      ...prevState,
      selectedTableShape: tableShape,
    }));
  };

  const onChooseTable = table => {
    setState(prevState => ({
      ...prevState,
      selectedTable: table,
    }));
  };

  const onCancel = () => {
    selectShape && selectShape(null); //remove shape selection if any
    setState(defaultState);
  };

  const onOk = () => {
    const { toolType, selectedSubTool, selectedTable, selectedTableShape } = state;
    const subToolType = selectedSubTool?.type;
    let hasError = false;

    const isBasicShapeType =
      toolType === TmsComponents.circle ||
      toolType === TmsComponents.rectangle ||
      toolType === TmsComponents.square ||
      toolType === TmsComponents.polygon;

    if (!toolType) {
      toast.warning(labels.DESIGNER_SELECT_TOOL, { autoClose: 2000 });
      return;
    }

    if (isBasicShapeType) {
      initShape(toolType);
    } else if (toolType === TmsComponents.staticImages) {
      if (FireboardUtils.isObjectBlank(selectedSubTool)) {
        toast.warning(labels.DESIGNER_SELECT_STATIC_SHAPE, { autoClose: 2000 });
        hasError = true;
      } else {
        initShape(subToolType);
      }
    } else if (toolType === TmsComponents.table) {
      if (FireboardUtils.isObjectBlank(selectedSubTool)) {
        toast.warning(labels.DESIGNER_SELECT_SEAT_CAPACITY, { autoClose: 2000 });
        hasError = true;
      } else if (FireboardUtils.isObjectBlank(selectedTable)) {
        toast.warning(labels.DESIGNER_SELECT_TABLE, { autoClose: 2000 });
        hasError = true;
      } else if (FireboardUtils.isObjectBlank(selectedTableShape)) {
        toast.warning(labels.DESIGNER_SELECT_TABLE_SHAPE, { autoClose: 2000 });
        hasError = true;
      } else {
        onSelectStation && onSelectStation(selectedTable, selectedTableShape?.value);
      }
    }

    if (!hasError) {
      setState(defaultState);
    }
  };

  return (
    <Box height={'100vh'} width={'100%'} bgcolor={'white'}>
      <Header
        onSave={onSave}
        onClose={closeLayoutEditor}
        onDeleteLayout={onDeleteLayout}
        storeLayoutBySensorGroup={storeLayoutBySensorGroup}
        selectedSensorGrpId={selectedSensorGrpId}
        onChangeSensorGroup={onChangeSensorGroup}
        onStart={onStart}
      />
      <ToolsWrapper
        getAllTablesInfo={getAllTablesInfo}
        getAssignedAndUnAssignedTables={getAssignedAndUnAssignedTables}
        selectedShape={selectedShape}
        onChangeShape={onChangeShape}
        state={state}
        onClickTool={onClickTool}
        onClickSubTool={onClickSubTool}
        onChooseOrientation={onChooseOrientation}
        onChooseTable={onChooseTable}
        onDeleteShape={onDeleteShape}
        onSave={onSave}
        onClose={closeLayoutEditor}
      />
      {state.isComponentAdding && (
        <Footer
          onCancel={onCancel}
          onOk={onOk}
        />
      )}
    </Box>
  );
};

export default LeftSection;
